<template>
    <button 
        type="button"
        @click.prevent="submitForm"
        class="
        px-2 py-1 h-8 text-sm rounded-md
        lg:px-4 lg:py-2 lg:h-12 lg:text-lg lg:rounded-lg
        border-2 border-transparent
        font-semibold text-skin-b-invt
        disabled:opacity-50  
        focus:outline-none focus:ring-0 
        transition duration-300 ease-in-out"
        :class="{
        'mr-2' : margin,
        'w-full' : wfull,
        'bg-skin-active128 hover:bg-skin-active96 disabled:hover:bg-skin-active128 focus:bg-skin-active128 active:bg-skin-active128' : color=='blue',
        'bg-red-600 hover:bg-red-700 disabled:hover:bg-red-600 focus:bg-red-600 active:bg-red-600' : color=='red',
         }"
    >
        <slot></slot>
    </button>
</template>
<script>
export default {
  components: {
    
  },
  props: {
    color: {
      type: String,
      default: 'blue',
    },
    wfull: {
      type: Boolean,
      default: true,
    },
    margin: {
      type: Boolean,
      default: false,
    },
  },
}
</script>